
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./ComingSoon.css";

const LAUNCH_DATE = new Date("2026-12-01T00:00:00");

export default function ComingSoon() {
  const [time, setTime] = useState({});
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const updateCountdown = () => {
      const diff = Math.max(0, LAUNCH_DATE.getTime() - Date.now());

      setTime({
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff / 3600000) % 24),
        minutes: Math.floor((diff / 60000) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Connect an API or email service here to save subscribers.
    setSubmitted(true);
    setEmail("");
  };

  return (
    <main className="coming-soon">
      <div className="cs-background" />
      <div className="cs-overlay" />

      <header className="cs-navbar">
        <Link to="/" className="cs-brand">
          <span className="cs-logo">D</span>
          <span className="cs-brand-text">
            Design 365
            <small>ARCHITECTURE & DESIGN</small>
          </span>
        </Link>

        <div className="cs-status">
          <span />
          A NEW PERSPECTIVE IS COMING
        </div>

        <a className="cs-contact" href="mailto:hello@atelierstudio.com">
          GET IN TOUCH <span>↗</span>
        </a>
      </header>

      <section className="cs-content">
        <div className="cs-eyebrow">
          <span />
          SPACES THAT SPEAK
          <span />
        </div>

        <h1>
          Building Smarter
          <br />
          <em>Through</em> BIM Engineering.
        </h1>

        <p className="cs-description">
          Delivering accurate, coordinated, and efficient Building Information Modeling (BIM) solutions for the architecture, engineering, and construction industry.
        </p>

        <div className="cs-launch-label">
          <span>✳</span>
          SOMETHING BEAUTIFUL IS TAKING SHAPE
        </div>

        <div className="cs-countdown">
          {[
            ["days", "DAYS"],
            ["hours", "HOURS"],
            ["minutes", "MINUTES"],
            ["seconds", "SECONDS"],
          ].map(([key, label]) => (
            <div className="cs-time-item" key={key}>
              <strong>{String(time[key] ?? 0).padStart(2, "0")}</strong>
              <small>{label}</small>
            </div>
          ))}
        </div>

        <div className="cs-notify">
          <p className="cs-notify-heading">
            BE THE FIRST TO EXPERIENCE IT
          </p>

          {submitted ? (
            <p className="cs-success" role="status">
              ✓ Thank you. You're on our launch list.
            </p>
          ) : (
            <form className="cs-form" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Enter your email address"
                aria-label="Email address"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <button type="submit">
                NOTIFY ME <span>↗</span>
              </button>
            </form>
          )}

          <p className="cs-privacy">
            No noise, just something worth waiting for.
          </p>
        </div>

        <div className="cs-scroll">
          <span />
          A NEW VISION IS ON THE HORIZON
        </div>
      </section>

      <div className="cs-vertical">
        DESIGNING TOMORROW'S SPACES
      </div>

      <footer className="cs-footer">
        <span>© {new Date().getFullYear()} Design 365</span>
        <span className="cs-footer-center">
          DESIGNED WITH INTENTION. BUILT TO INSPIRE.
        </span>
        <a href="mailto:hello@atelierstudio.com">
          LET'S CREATE SOMETHING <span>↗</span>
        </a>
      </footer>
    </main>
  );
}
